var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1562 5.04338C19.1329 4.89588 18.8963 3.57088 17.9363 2.60338C16.9721 1.66004 15.6421 1.42671 15.4937 1.40338C15.2962 1.37088 15.0946 1.41254 14.9254 1.51754C14.8662 1.55421 13.9971 2.09838 12.2812 3.54921C13.1637 3.86088 14.3046 4.40171 15.2296 5.30671C16.1579 6.21504 16.7129 7.33254 17.0312 8.19921C18.4646 6.52421 19.0037 5.67588 19.0396 5.61754C19.1462 5.44671 19.1879 5.24254 19.1562 5.04338Z",
    fill: "#6F7F8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.795 4.85156C9.90083 5.65823 8.86 6.63823 7.66833 7.82156C2.61583 12.8382 1.29083 14.8441 1.23667 14.9266C1.16083 15.0432 1.115 15.1774 1.10417 15.3157L0.838333 18.7082C0.82 18.9516 0.9075 19.1899 1.08 19.3624C1.23667 19.5191 1.44917 19.6066 1.67 19.6066C1.69083 19.6066 1.7125 19.6066 1.73417 19.6041L5.15167 19.3407C5.28917 19.3299 5.42167 19.2857 5.5375 19.2116C5.62083 19.1582 7.64 17.8424 12.6917 12.8266C13.91 11.6166 14.915 10.5632 15.7375 9.6624C15.6117 9.12156 15.1725 7.57823 14.0667 6.4974C12.945 5.3999 11.3317 4.9699 10.795 4.85156Z",
    fill: "#6F7F8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil1);
export default __webpack_public_path__ + "static/media/pencil 1.f0614af6e835a040e057482be5ad905e.svg";
export { ForwardRef as ReactComponent };